import config from "environment";
import { getRequest, postRequest } from "./client";
import { Asset, CreateAssetInWorkspacePayload } from "effno-core";

const { baseApi } = config;

export async function apiGetAsset(id: string) : Promise<Asset | null> {
  const fetchURL = `${baseApi}/assets/${id}`;
  return await getRequest(fetchURL, "API/apiGetAsset");
}

export async function apiGetAssetsForWorkspace(workspaceId: string) : Promise<Asset[] | null> {
  const fetchURL = `${baseApi}/assets/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetAssetsForWorkspace");
}

export async function apiCreateAssetInWorkspace(payload: CreateAssetInWorkspacePayload) : Promise<Asset | null> {
  const fetchURL = `${baseApi}/assets/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateAssetInWorkspace");
}

export async function apiDeleteAsset(assetId: string) : Promise<Asset | null> {
  const fetchURL = `${baseApi}/assets/delete/${assetId}`;
  return await getRequest(fetchURL, "API/apiDeleteAsset");
}
